import { jwtDecode } from "jwt-decode";

export default class FirebaseTokenValidator {
  async decodeToken(token) {
    try {
      return jwtDecode(token);
    } catch (error) {
      return false;
    }
  }

  async validate(token) {
    const decodedToken = await this.decodeToken(token);
    if (!decodedToken) {
      return { isValid: false, error: "Invalid token format" };
    }
    const expiryTime = decodedToken?.exp ? decodedToken?.exp * 1000 : 0; // Convert to milliseconds
    const currentTime = Date.now();
    if (expiryTime < currentTime) {
      return { isValid: false, error: "Token has expired" };
    }
    // Optionally, check for "nbf issuer and audience of token" (not before) claim if present
    if (
      decodedToken.aud !== process.env.REACT_APP_JWT_TOKEN_AUDIENCE &&
      decodedToken.iss !== process.env.REACT_APP_JWT_TOKEN_ISSUER
    ) {
      return { isValid: false, error: "Invalid id token" };
    }
    return { isValid: true, decodedToken }; // All checks passed
  }

  async getToken() {
    return localStorage.getItem("avEcoAccessToken");
  }

  async removeToken() {
    localStorage.removeItem("avEcoAccessToken");
  }
}
